/* src/app/_shared/components/day-move-buttons/day-move-buttons.component.scss */
:host {
  display: block;
  width: 100%;
}
:host.hide {
  transform: translateY(-100%);
}
.move-buttons {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.move-buttons app-button {
  --icon-margin: 0;
  --active-background-color: var(--ion-color-light);
  --background-color: transparent;
  --text-color: var(--ion-color-primary);
  font-weight: bold;
  text-align: center;
}
.move-buttons app-button ion-icon {
  margin: 0;
}
/*# sourceMappingURL=day-move-buttons.component-AYTGMRZ5.css.map */
